import React from "react";
import './ButtonComponent.scss'

interface ButtonComponentProps {
    label: string
    onButtonClick: () => void
    className?: string
    disabled?: boolean
    secondary?: boolean
    disableOnClick?: boolean
}

export const ButtonComponent: React.FC<ButtonComponentProps> = ({label, onButtonClick, className, disabled, secondary, disableOnClick}: ButtonComponentProps) => {

    const [clicked, setClicked] = React.useState(false)

    const onClick = () => {
        if (disableOnClick) {
            setClicked(true)
        }
        onButtonClick()
    }

    return (
        <div
            className={`${className ? className : ''} button-component-container  button flex-center 
            ${secondary ? 'secondary-button-color secondary-button-border' : 'primary-background primary-color'}
            ${disabled || clicked ? 'disabled' : ''}`}
        onClick={() => onClick()}>
            <span className={`user-select-none`}>{label}</span>
        </div>
    )

}